<template lang="pug">
.flex.flex-column
  v-app-bar.flex-none(color="secondary")
    v-app-bar-nav-icon(@click.stop="drawer = !drawer")
    v-toolbar-title 概况
    .flex.justify-end(style="opacity: 0.7")
      v-btn(@click="printReceipt", text, color="secondary", height="28px", elevation="0", disabled) 盘点小票
      v-btn(@click="reloadApp", height="28px", width="28px", elevation="0", icon)
        v-icon mdi-refresh
  v-navigation-drawer(v-model="drawer", bottom, absolute, height="auto")
    v-list-item
      v-list-item-content
        v-list-item-title.title
          | Kanga Zone 商户
        v-list-item-subtitle
          | v{{ version }} &copy;2018-{{ new Date().getFullYear() }} 诗序软件
    v-divider
    v-list(dense, nav)
      v-list-item
        v-icon mdi-account
        span.ml-1 {{ user.name }}
      v-list-item(@click="logout")
        v-icon mdi-logout
        span.ml-1 退出登录

  v-container.flex.flex-column.stats.flex-1
    .flex.text.justify-between.items-center.align-stretch.flex-1
      v-card(@click="goBookingList({ status: 'in_service' })", :elevation="5")
        .number {{ stats.checkedInCount }}
        .label 游玩中人数
          .hint 点击查看游玩中订单
      v-card(@click="goBookingList({ due: true })", :elevation="5")
        .number {{ stats.dueCount }}
        .label 即将超时人数
          .hint 点击查看即将超时订单
      v-card.action.primary(@click="goBookingCreate", :elevation="5")
        v-icon mdi-location-enter
        v-card-actions 入场登记
    .flex.text.justify-between.items-center.pt-4.align-stretch.flex-1
      v-card(@click="goBookingList({ date: today })", :elevation="5")
        .number {{ stats.customers }}
        .label 当日人数
          .hint 点击查看当日订单
      v-card(:elevation="5")
        .number ￥{{ stats.assets.toFixed(0) }}
        .label 当日流水
          .hint 包含消费和充值
      v-card.action.secondary(@click="goAdmin", :elevation="5")
        v-icon mdi-view-dashboard
        v-card-actions 进入后台
</template>

<script>
import { sync } from "vuex-pathify";
import { logout } from "../services/auth";
import { getStats } from "../services/store";
import { moment } from "../utils/moment";
import { statsReceiptPrint } from "../services/payment";
// @ is an alias to /src
export default {
  name: "home",
  data() {
    return {
      version: process.env.VERSION,
      drawer: false,
      today: moment().format("YYYY-MM-DD")
    };
  },
  computed: {
    user: sync("auth/user"),
    token: sync("auth/token"),
    stats: sync("store/stats")
  },
  mounted() {
    this.getStats();
  },
  methods: {
    async printReceipt() {
      await statsReceiptPrint();
    },
    reloadApp() {
      window.location.reload();
    },
    async getStats() {
      const res = await getStats();
      this.stats = res.data;
    },
    goBookingList(query) {
      this.$router.push({
        name: "bookingList",
        query
      });
    },
    goBookingCreate({ type }) {
      this.$router.push({
        name: "bookingCreate"
      });
    },
    goAdmin() {
      const adminHome = process.env.VUE_APP_ADMIN_HOME;
      const token = window.localStorage.getItem("token");
      const appName = encodeURIComponent("Kangazone商户");
      const currentUrl = encodeURIComponent(window.location.href);
      if (!adminHome || !token) return;
      window.location.href = `${adminHome}?fromApp=${appName}&fromAppUrl=${currentUrl}&token=${token}`;
    },
    logout() {
      logout();
    }
  }
};
</script>

<style lang="stylus" scoped>
.container {
  max-width: none;
}

.v-navigation-drawer--close {
  height: 0 !important;
}

.stats .v-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 32%;
  height: auto;

  .number {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.75rem;
    font-weight: lighter;
    flex: 2;
  }

  .label {
    font-size: 1rem;
    font-weight: normal;
    flex: 1;

    .hint {
      font-size: 0.7rem;
      opacity: 0.6;
    }
  }

  &.action {
    &.disabled {
      opacity: 0.5;
    }

    .v-card__actions {
      justify-content: center;
      font-size: 1.75rem;
    }
  }
}
</style>